/**

    * Application Name: Zevcore unolo Backend
    * Application Version: 1.0
    * Author: Zevcore Private Limited
    * Created Date: 17.05.2023
    * Last Modified Date: 17.05.2023
    * Developer Name: Anand_Krishna

**/

import { url } from "../../../services/url";
import axios from "axios";

export const LoginImageUrl = `${url.baseUrl}public/images/loggedIn/`;

const fetchCredentials = async () => {
  try {
    // Retrieve the credentials
    const credentials = await localStorage.getItem("token");
    if (credentials) {
      return {
        headers: {
          "x-access-token": credentials,
        },
      };
    } else {
      console.log("No credentials stored");
    }
  } catch (error) {
    console.log("Keychain couldn't be accessed!", error);
  }
  return false;
};

const AttendanceUrl = {
  attendance_Url: `${url.apiUrl}/attendance`,
  attendanceSearch_Url: `${url.apiUrl}/attendance_search`,
};

// For handle get Location Type data list
export const handleGetAllAttendance = async (request) => {
  try {
    const config = await fetchCredentials();
    const response = await axios.get(AttendanceUrl.attendance_Url, config);
    return response;
  } catch (error) {
    return error.response;
  }
};

// For handle get location search data list
export const handleSearchAllAttendance = async (request) => {
  try {
    const config = await fetchCredentials();
    const response = await axios.post(
      AttendanceUrl.attendanceSearch_Url,
      request,
      config
    );
    return response;
  } catch (error) {
    return error.response;
  }
};
